module.exports = __webpack_public_path__ + "img/9bfed68.jpg";